import {useTranslation} from "next-i18next"
import DataContext from "../../../context/DataContext"
import Button from "../../reusable/components/Button"
import Typography from "../../reusable/Typography/Typography"
import React, {useContext} from "react"
import urlParams from "../../../utility/UrlParams"
import {filterUrl} from "../../filter/FilterUrl"
import {CollectionName} from "../../../constants"
import {useRouter} from "next/router"

function BrandWorldFactsSection() {
	const {brandWorld} = useContext(DataContext)
	const router = useRouter()
	const {t} = useTranslation()

	return (
		<div className="container d-flex align-items-center justify-content-start col-12 flex-column gap-4">
			<div style={{marginTop: "60px", maxWidth: "100%", overflowX: "auto", overflowY: "hidden"}}
				className="d-flex align-items-center hide-overflow-scrollbar px-md-0 px-3 justify-content-md-center flex-nowrap flex-md-wrap row g-2 ps-0">
				{brandWorld?.facts ? brandWorld?.facts?.map(({number, subTitle, description}, index) =>
					<div key={index}
						className="col-auto col-md-6">
						<div
							className="d-flex align-items-center fact-box justify-content-center flex-column">
							<div className="d-flex align-items-center  justify-content-center flex-column">
								<Typography variant="bodyLgBlack"
									className="typography-amount text-white">
									{number}
								</Typography>
								<Typography variant="bodySm"
									className="brand-fact-typography-subtitle">
									{subTitle}
								</Typography>
							</div>
							<Typography variant="bodySm"
								className="typography-description">
								{description}
							</Typography>
						</div>
					</div>
				) : null}
			</div>
			<Button onClick={() => {
				router.push(`${filterUrl({[urlParams.brand]: brandWorld.brandSlug, [urlParams.categories]: brandWorld.factSectionCtaCategorySlug || ""}, urlParams.brand, brandWorld.brandSlug, CollectionName.BrandWorld, CollectionName.BrandWorld, brandWorld.brandSlug)}#products-listing`, null, {shallow: true})
			}}
			label={t(brandWorld.factSectionCtaText)}
			style={{marginTop: "1rem"}}
			fontSizeSmall
			textColor="#fff"
			bgColor={brandWorld.buttonsBackgroundColor} />
		</div>
	)
}

export default BrandWorldFactsSection
